<div class="flex">
  @for (item of stars; track $index) {
    <div [style]="style">
      <svg
        [attr.fill]="
          $index + 1 <= (hoverRating || rating())
            ? 'gold'
            : $index + 0.5 <= (hoverRating || rating())
              ? 'url(#half)'
              : 'none'
        "
        viewBox="0 0 25 25"
        (click)="onClick($event, $index)"
        (mouseenter)="onMouseEnter($event, $index)"
        (mouseleave)="onMouseLeave()">
        <defs>
          <linearGradient id="half">
            <stop offset="50%" stop-color="gold" />
            <stop offset="50%" stop-color="transparent" stop-opacity="1" />
          </linearGradient>
        </defs>
        <polygon
          points="12.5,2.5 16,9 23,9 18,14 20,22 12.5,18 5,22 7,14 2,9 9,9"
          stroke="gold"
          stroke-width="1" />
      </svg>
    </div>
  }
</div>
